import { css } from '@emotion/css';
import { Col, Row } from 'antd';
import { FilterBarConstant } from 'src/constants';
import {
  useAccountBalance,
  useCumulativeOrders,
  useFindAccountStatus,
  usePositions,
  useSubmittedAccountSelector,
  useTransfers,
} from 'src/hooks';
import { MTabs, MTypography } from 'src/lib';
import { OrderStatusLabel } from 'src/models';
import { ColorConstant, Spacing } from 'src/styles';
import { mapFilterToGetOrderListQueryParamsDto } from 'src/utils';

import { AccountSummary } from './AccountSummary';
import { NonTradedHoldingsTable } from './NonTradedHoldingsTable';
import { OfferOrdersTable } from './OfferOrdersTable';
import { OrdersTable } from './OrdersTable';
import { SecurityHoldingsTable } from './SecurityHoldingsTable';

const titleRowStyle = css`
  ${Spacing.mt32}
  ${Spacing.mb12}
`;

export const SummaryPage = () => {
  const { account } = useSubmittedAccountSelector();
  useAccountBalance();
  usePositions({
    dependency: [account.accountId],
  });

  useTransfers({
    dependency: [account.accountId],
  });
  useCumulativeOrders({
    queryParamsDto: mapFilterToGetOrderListQueryParamsDto({
      filterBy: [`${OrderStatusLabel.WORKING}_${FilterBarConstant.StatusCategory.Order}`],
      timeline: FilterBarConstant.FixedTimeline.ThisYear,
    }),
    dependency: [account.accountId],
  });
  useFindAccountStatus({ dependency: [account.accountId] });

  return (
    <Row>
      <Row className={titleRowStyle}>
        <MTypography variant='h4' weight='semibold' color={ColorConstant.BRAND6}>
          Summary
        </MTypography>
      </Row>
      <Row>
        <Col span={24} className={Spacing.my16}>
          <AccountSummary />
        </Col>
        <Col span={24} className={Spacing.my16}>
          <MTabs
            items={[
              {
                key: 'holdings',
                label: 'Holdings',
                children: (
                  <Row>
                    <Col span={24} id='securities-section' className={Spacing.my16}>
                      <SecurityHoldingsTable />
                    </Col>
                    <Col span={24} id='non-trade-holdings-section' className={Spacing.my16}>
                      <NonTradedHoldingsTable />
                    </Col>
                  </Row>
                ),
              },
              {
                key: 'orders',
                label: 'Orders',
                children: (
                  <Row>
                    <Col span={24} id='orders-section' className={Spacing.my16}>
                      <OrdersTable />
                    </Col>
                    <Col span={24} id='offer-orders-section' className={Spacing.my16}>
                      <OfferOrdersTable />
                    </Col>
                  </Row>
                ),
              },
            ]}
          />
        </Col>
      </Row>
    </Row>
  );
};
